// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateWorkbookParameterSetsMutationVariables = Types.Exact<{
  workbookId: Types.Scalars["ID"]["input"];
  parameterSets: Types.Scalars["JSON"]["input"];
}>;

export type UpdateWorkbookParameterSetsMutation = {
  __typename?: "Mutation";
  updateWorkbookParameterSets?: {
    __typename?: "Workbook";
    id: string;
    parameterRefAliases: Array<string>;
    parameterSets: Array<{
      __typename?: "WorkbookParameterSet";
      id: string;
      name: string;
      paramValues: any;
    }>;
    aliasParamMapList: Array<{
      __typename?: "AliasParamMap";
      id: string;
      name: string;
      parameters: any;
    }>;
  } | null;
};

export const UpdateWorkbookParameterSetsDocument = gql`
  mutation UpdateWorkbookParameterSets(
    $workbookId: ID!
    $parameterSets: JSON!
  ) {
    updateWorkbookParameterSets(
      workbookId: $workbookId
      parameterSets: $parameterSets
    ) {
      id
      parameterSets {
        id
        name
        paramValues
      }
      parameterRefAliases
      aliasParamMapList {
        id
        name
        parameters
      }
    }
  }
`;
export type UpdateWorkbookParameterSetsMutationFn = Apollo.MutationFunction<
  UpdateWorkbookParameterSetsMutation,
  UpdateWorkbookParameterSetsMutationVariables
>;

/**
 * __useUpdateWorkbookParameterSetsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkbookParameterSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkbookParameterSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkbookParameterSetsMutation, { data, loading, error }] = useUpdateWorkbookParameterSetsMutation({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *      parameterSets: // value for 'parameterSets'
 *   },
 * });
 */
export function useUpdateWorkbookParameterSetsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkbookParameterSetsMutation,
    UpdateWorkbookParameterSetsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkbookParameterSetsMutation,
    UpdateWorkbookParameterSetsMutationVariables
  >(UpdateWorkbookParameterSetsDocument, options);
}
export type UpdateWorkbookParameterSetsMutationHookResult = ReturnType<
  typeof useUpdateWorkbookParameterSetsMutation
>;
export type UpdateWorkbookParameterSetsMutationResult =
  Apollo.MutationResult<UpdateWorkbookParameterSetsMutation>;
export type UpdateWorkbookParameterSetsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateWorkbookParameterSetsMutation,
    UpdateWorkbookParameterSetsMutationVariables
  >;
